//@ts-check
import { Controller } from "@hotwired/stimulus";
import { debugToast } from "../components/debug-toast";
import {
  LICENSING_SELECTION_CHANGE,
  LicensingSelector,
} from "../components/licensing-selector/LicensingSelector";
import { ServerSync } from "../components/licensing-selector/ServerSync";

addEventListener("pageshow", () => {
  debugToast("pageshow");
});

document.addEventListener("DOMContentLoaded", () => {
  debugToast("DOMContentLoaded");
});

/**
 * Handles changes to licensing options on the font detail page before the fonts are added to the cart.
 *
 * - updates the server with the selected options
 * - updates the prices on the page based on the lincense multiplier returned from the server
 */
export default class extends Controller {
  connect() {
    console.log("LicensingOptionsSelectorController connected", this.element);
    debugToast("LicensingOptionsSelectorController connected");

    this.licensingSelector = new LicensingSelector(this.element);

    this.listenToLicensingSelectionChange();

    this.serverSync = new ServerSync(this.element, this.licensingSelector);

    // Fired on initial load and when the browser restores the page from bfcache
    // (back/forward navigation). We re-sync because the cart endpoint might have
    // optimized the cart in the meantime, so the items in the cart might differ.
    addEventListener("pageshow", () => {
      debugToast("LicensingOptionsSelectorController pageshow");
      this.syncToServer();
    });

    console.log("LicensingOptionsSelectorController initialized");
  }

  disconnect() {
    debugToast("LicensingOptionsSelectorController disconnected");
    if (this._licensingSelectionChangeHandler) {
      this.element.removeEventListener(
        LICENSING_SELECTION_CHANGE,
        this._licensingSelectionChangeHandler
      );
    }
  }

  // --- List and update backend ---

  listenToLicensingSelectionChange() {
    this._licensingSelectionChangeHandler = () => this.syncToServer();

    this.element.addEventListener(
      LICENSING_SELECTION_CHANGE,
      this._licensingSelectionChangeHandler
    );
  }

  syncToServer() {
    this.serverSync.syncToServer();
  }
}
